export default {
  brand: {
    name: "Basetao Sheet",
    tagline: "Das Basetao-Ressourcen-Hub",
  },
  nav: {
    spreadsheet: "Tabelle",
    reviews: "Bewertungen",
    shipping: "Versand",
    coupons: "Gutscheine",
    warehouse: "Lager",
    qc: "QC",
    guides: "Leitfäden",
    safety: "Sicherheit",
    cta: "Tabelle erkunden",
    home: "Startseite",
    shoppingGuide: "Einkaufsführer",
  },
  lang: {
    label: "Sprache",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  categories: {
    title: "Nach Kategorie einkaufen",
    dropdownLabel: "Kategorien durchsuchen",
    browseCta: "Alle Kategorien ansehen",
    shoes: "Schuhe",
    hoodies: "Hoodies / Pullover",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen / Shorts",
    headwear: "Kopfbedeckung",
    sets: "Sets",
    underwear: "Unterwäsche / Unterhosen",
    jersey: "Trikot",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
  },
  hero: {
    eyebrow: "DAS BASETAO-RESSOURCEN-HUB",
    title: "Basetao Spreadsheet — Produkte, Verkäufer, QC & Versand schneller finden",
    subtitle:
      "Entdecken Sie das Basetao Spreadsheet: organisierte Produktressourcen, Verkäuferleitfäden, QC-Informationen, Versandleitfäden, Lagertipps, Bewertungen und praktische Kaufressourcen — alles an einem Ort.",
    primaryCta: "Basetao Spreadsheet",
    secondaryCta: "Jetzt kaufen",
    trust: "Unabhängige Ressource • Regelmäßig aktualisiert • Einsteigerfreundlich",
  },
  what: {
    title: "Was ist ein Basetao Spreadsheet?",
    subtitle:
      "Ein Basetao Spreadsheet ist eine strukturierte Möglichkeit, Produktinformationen, Verkäufer, Links und Kaufressourcen zu organisieren und zu entdecken. Es macht die Produktsuche schneller und übersichtlicher.",
    card1Title: "Produkte finden",
    card1Desc: "Entdecken Sie organisierte Produktressourcen.",
    card2Title: "Verkäufer prüfen",
    card2Desc: "Verkäuferinformationen auf einen Blick.",
    card3Title: "QC prüfen",
    card3Desc: "Verstehen Sie die Qualitätskontroll-Details.",
    card4Title: "Versand vergleichen",
    card4Desc: "Versandvariablen klar verstehen.",
    cta: "Das Basetao Spreadsheet erkunden",
  },
  popular: {
    title: "Beliebte Suchanfragen",
    subtitle: "Die Themen, nach denen Käufer bei Basetao am häufigsten suchen.",
    items: [
      "Basetao Spreadsheet",
      "Basetao Bewertung",
      "Basetao Versandkosten",
      "Basetao Gutschein",
      "Basetao Rabattcode",
      "Basetao Lager",
      "Ist Basetao seriös?",
      "Basetao QC",
    ],
  },
  why: {
    title: "Warum diese Website nutzen?",
    subtitle: "Damit Ihre Basetao-Recherche klarer und schneller wird.",
    items: [
      { title: "Organisiert", desc: "Alles an einem klaren Ort strukturiert." },
      { title: "Praktisch", desc: "Fokussiert auf echte Kaufentscheidungen." },
      { title: "Transparent", desc: "Wir erklären Grenzen und Unsicherheiten offen." },
      { title: "Mehrsprachig", desc: "Verfügbar in fünf Sprachen." },
    ],
  },
  how: {
    title: "So funktioniert es",
    subtitle: "Ein einfacher Rechercheablauf von der Entdeckung bis zum Kauf.",
    steps: [
      { title: "Finden", desc: "Organisierte Produkt- und Verkäuferressourcen durchsuchen." },
      { title: "Recherchieren", desc: "Angebote, Verkäufer und Links prüfen." },
      { title: "Vergleichen", desc: "QC, Versand und Preis abwägen." },
      { title: "Prüfen", desc: "Sicherheitshinweise und Warnsignale beachten." },
      { title: "Fortfahren", desc: "Zur Hauptwebsite gehen und kaufen." },
    ],
  },
  safety: {
    title: "Wichtiger Sicherheitshinweis",
    text:
      "Produktangebote, Verkäufer, Versandkosten und Aktionen können sich ändern. Leitfäden und Tabellen organisieren Informationen, können aber Produktqualität, Verkäuferzuverlässigkeit oder Lieferergebnisse nicht garantieren.",
    links: [
      "Verkäufersicherheit",
      "QC-Leitfaden",
      "Versandrisiko",
      "Zahlungssicherheit",
      "Ist Basetao seriös?",
    ],
  },
  faq: {
    title: "Häufig gestellte Fragen",
    items: [
      {
        q: "Was ist ein Basetao Spreadsheet?",
        a: "Ein strukturiertes Dokument, das Produkte, Verkäufer, Preise, QC-Fotos und Versanddetails an einem Ort organisiert und die Recherche übersichtlicher macht.",
      },
      {
        q: "Wie funktioniert ein Basetao Spreadsheet?",
        a: "Es gruppiert nützliche Informationen in Spalten und Kategorien, sodass Sie Artikel schneller finden, vergleichen und verfolgen als beim Durchscrollen verstreuter Nachrichten.",
      },
      {
        q: "Ist Basetao seriös?",
        a: "Basetao ist ein seit Langem genutzter Einkaufsagent vieler internationaler Käufer. Diese Website ist unabhängig — prüfen Sie Verkäufer und Bestellungen immer selbst.",
      },
      {
        q: "Wie viel kostet der Basetao-Versand?",
        a: "Die Kosten hängen von Gewicht, Abmessungen, Ziel, Methode und Versicherung ab. Aktuelle Tarife finden Sie im Versandleitfaden der Hauptwebsite.",
      },
      {
        q: "Wo finde ich Basetao-Gutscheine?",
        a: "Aktionen ändern sich oft. Suchen Sie nach verifizierten, aktuellen Angeboten statt nach abgelaufenen Codes von anderswo.",
      },
    ],
  },
  finalCta: {
    title: "Bereit, das Basetao Spreadsheet zu erkunden?",
    subtitle: "Durchsuchen Sie organisierte Produkte, Verkäufer und Ressourcen auf der Hauptwebsite.",
    button: "Das Basetao Spreadsheet erkunden",
  },
  guides: {
    title: "Basetao-Leitfäden & Ressourcen",
    subtitle:
      "Grundlagenartikel zu Tabelle, Bewertungen, Versand, Gutscheinen, Lager und Sicherheit.",
    readMore: "Artikel lesen",
  },
  footer: {
    description:
      "Eine unabhängige Informationsressource über das Basetao Spreadsheet. Nicht mit Basetao verbunden oder von ihm unterstützt.",
    resources: "Ressourcen",
    about: "Über uns",
    contact: "Kontakt",
    privacy: "Datenschutz",
    terms: "Bedingungen",
    disclaimer: "Haftungsausschluss",
    cookie: "Cookie-Richtlinie",
    languages: "Sprachen",
    copyright: "© 2026 Basetao Sheet. Alle Rechte vorbehalten.",
  },
  article: {
    breadcrumb: "Startseite › Leitfäden",
    h1: "Basetao Spreadsheet: Der komplette Leitfaden zu Produkten, Verkäufern, QC & Versand",
    updated: "Zuletzt aktualisiert: 19. August 2026",
    quickAnswerLabel: "Kurze Antwort",
    quickAnswer:
      "Ein Basetao Spreadsheet ist ein geteiltes, strukturiertes Dokument, das Produkte, Verkäufer, Preise, QC-Fotos und Versanddetails an einem Ort organisiert. Es hilft Ihnen, Artikel schneller zu finden, Verkäufer zu vergleichen und Bestellungen zu verfolgen — viel einfacher als das Durchscrollen verstreuter Nachrichten.",
    tocTitle: "Inhaltsverzeichnis",
    sections: [
      {
        title: "Was ist ein Basetao Spreadsheet?",
        body: [
          "Ein Basetao Spreadsheet ist im Grunde eine geteilte Tabelle, die alles zusammenführt, was ein Käufer für die Recherche braucht. Statt Chat-Verlauf, Verkäuferalben oder Lesezeichen zu durchsuchen, finden Sie Produktnamen, Bilder, Verkäuferdetails, Preise, QC-Status und Versandnotizen in klaren Spalten.",
          "Diese Organisation ist besonders nützlich, wenn Sie viele Artikel gleichzeitig vergleichen. Die Tabelle dient als einzige Quelle, die Sie schnell überfliegen können — das spart Zeit und verringert das Risiko, ähnliche Produkte verschiedener Verkäufer zu verwechseln.",
        ],
      },
      {
        title: "Warum Käufer ein Basetao Spreadsheet nutzen",
        body: [
          "Der Hauptgrund ist Geschwindigkeit. Wenn die Recherche strukturiert ist, verbringen Sie weniger Zeit mit Suchen und mehr mit Entscheiden. Eine Tabelle hält außerdem fest, was Sie gefunden, bestellt und noch zu prüfen haben.",
          "Bei größeren Bestellungen oder Wiederholungskäufen hilft eine Tabelle, konsistent zu bleiben. Sie verfolgen vertrauenswürdige Verkäufer, notieren Artikel, die die QC bestanden haben, und merken sich Versandoptionen, die gut funktioniert haben.",
        ],
      },
      {
        title: "Wie ein Basetao Spreadsheet organisiert ist",
        body: [
          "Eine typische Tabelle gruppiert Informationen in wenige Kernspalten: Produktname, Bild, Kategorie, Verkäufer, Preis, QC-Status und ein Link zum Artikel. Manche enthalten auch Versandgewicht, Lagernotizen und persönliche Anmerkungen.",
          "Die Kategorien folgen meist der Shop-Struktur — Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Kopfbedeckung, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und Sonstiges. So gelangen Sie direkt zum gewünschten Bereich.",
        ],
      },
      {
        title: "Produkte mit einem Basetao Spreadsheet finden",
        body: [
          "Beginnen Sie mit der gewünschten Kategorie und überfliegen Sie Produktnamen und Bilder nach passenden Artikeln. Nutzen Sie die Spalten Verkäufer und Preis, um die Auswahl einzugrenzen.",
          "Sobald Sie einen vielversprechenden Artikel finden, öffnen Sie den Link auf der Hauptwebsite für vollständige Details, Verfügbarkeit und aktuelle Angebote. Die Tabelle ist der Ausgangspunkt — das Angebot selbst bestätigt die Einzelheiten.",
        ],
      },
      {
        title: "Verkäufer recherchieren",
        body: [
          "Verkäuferrecherche ist wichtig, weil Qualität und Zuverlässigkeit variieren. Achten Sie darauf, ob ein Verkäufer regelmäßig auftaucht, wie seine Produkte beschrieben sind und ob frühere QC-Notizen wiederkehrende Probleme melden.",
          "Behandeln Sie Verkäuferinformationen als erstes Signal, nicht als Garantie. Bedingungen ändern sich — prüfen Sie jeden Verkäufer bei jeder Bestellung erneut, besonders bei teureren Artikeln.",
        ],
      },
      {
        title: "QC-Fotos verstehen",
        body: [
          "QC-Fotos (Qualitätskontrolle) gehören zu den wertvollsten Teilen des Kaufprozesses. Sie zeigen den tatsächlichen Artikel vor dem Versand, sodass Sie Größen-, Farb- oder Mängelprobleme früh erkennen.",
          "Vergleichen Sie QC-Fotos mit dem ursprünglichen Angebot. Achten Sie auf Nähte, Logos, Farben und Maße. Wenn etwas ungewöhnlich aussieht, fragen Sie nach, bevor der Artikel versendet wird.",
        ],
      },
      {
        title: "Versandkosten und Optionen",
        body: [
          "Versandkosten sind keine feste Zahl — sie hängen von Paketgewicht, Abmessungen, Zielland, gewählter Methode und Versicherung ab. Schwerere oder sperrigere Pakete kosten in der Regel mehr.",
          "Verschiedene Versandlinien balancieren Geschwindigkeit und Preis. Manche sind schneller, aber teurer, andere günstiger, aber langsamer. Die richtige Wahl hängt davon ab, wie schnell Sie das Paket brauchen und wie viel Sie ausgeben möchten.",
        ],
      },
      {
        title: "Häufige Fehler vermeiden",
        body: [
          "Ein häufiger Fehler ist, vor der Prüfung der QC-Fotos zu bestellen, was die Problemlösung erschwert. Ein anderer ist, das Gewicht bei der Versandplanung zu ignorieren, was zu einer unerwartet hohen Rechnung führen kann.",
          "Auch ähnliche Artikel verschiedener Verkäufer lassen sich leicht verwechseln. Die Tabelle zu nutzen, um festzuhalten, welcher Artikel von welchem Verkäufer stammt, vermeidet Verwirrung und hält Bestellungen organisiert.",
        ],
      },
      {
        title: "Sicherheit und Warnsignale",
        body: [
          "Bewahren Sie eine gesunde Vorsicht. Seien Sie skeptisch bei Verkäufern ohne Historie, unrealistisch günstigen Preisen oder Angeboten mit unpassenden Fotos. Kleine Anzahlungen oder ungewöhnliche Zahlungsaufforderungen können ebenfalls Warnsignale sein.",
          "Diese Website ist eine unabhängige Ressource — prüfen Sie Informationen immer selbst. Kein Leitfaden kann Produktqualität, Verkäuferzuverlässigkeit oder Lieferergebnisse garantieren. Nutzen Sie diese Ressourcen als hilfreichen Ausgangspunkt, nicht als Ersatz für Ihr eigenes Urteilsvermögen.",
        ],
      },
    ],
    tableTitle: "Tabelle vs. verstreute Notizen",
    tableHeaders: ["Funktion", "Basetao Spreadsheet", "Manuelle Notizen"],
    tableRows: [
      ["Produktentdeckung", "Organisiert und filterbar", "Schwer zu durchsuchen"],
      ["Verkäuferrecherche", "Strukturierte Spalten", "Verstreute Nachrichten"],
      ["QC-Verfolgung", "Eigene QC-Felder", "Mit Chat vermischt"],
      ["Versandplanung", "Auf einen Blick klar", "Erfordert Suchen"],
      ["Ideal für", "Ernsthafte Recherche", "Gelegentliches Stöbern"],
    ],
    faqTitle: "Häufig gestellte Fragen",
    faqs: [
      {
        q: "Ist ein Basetao Spreadsheet kostenlos?",
        a: "Tabellen sind meist geteilte Ressourcen. Die aktuelle Version und Zugangsdetails finden Sie auf der Hauptwebsite.",
      },
      {
        q: "Wie oft wird die Tabelle aktualisiert?",
        a: "Updates variieren. Angebote, Verkäufer und Preise ändern sich — behandeln Sie die Informationen als Momentaufnahme und bestätigen Sie Details vor der Bestellung auf der Hauptwebsite.",
      },
      {
        q: "Kann ich die Tabelle auf dem Handy nutzen?",
        a: "Die meisten strukturierten Dokumente funktionieren auf Desktop und Mobilgerät. Für den Vergleich vieler Spalten ist ein größerer Bildschirm oft angenehmer.",
      },
      {
        q: "Garantiert die Tabelle die Produktqualität?",
        a: "Nein. Sie organisiert Informationen, kann aber Qualität, Verkäuferzuverlässigkeit oder Lieferergebnisse nicht garantieren. Prüfen Sie immer QC-Fotos und machen Sie eigene Checks.",
      },
    ],
    conclusion:
      "Ein Basetao Spreadsheet ist ein praktisches Werkzeug für alle, die Produkte, Verkäufer, QC und Versand effizienter recherchieren möchten. Es führt verstreute Informationen zu einer klaren Ansicht zusammen, sodass Sie bessere Entscheidungen treffen und weniger Zeit mit Suchen verbringen. Denken Sie daran, dass sich Details ändern: Nutzen Sie die Tabelle als Leitfaden und bestätigen Sie die neuesten Informationen vor dem Kauf immer auf der Hauptwebsite.",
    relatedTitle: "Verwandte Ressourcen",
    backHome: "Zurück zur Startseite",
    ctaLabel: "Das Basetao Spreadsheet erkunden",
    conclusionTitle: "Fazit",
    readGuide: "Leitfaden lesen",
    toc: [
      "Was ist ein Basetao Spreadsheet?",
      "Warum Käufer ein Basetao Spreadsheet nutzen",
      "Wie ein Basetao Spreadsheet organisiert ist",
      "Produkte finden",
      "Verkäufer recherchieren",
      "QC-Fotos verstehen",
      "Versandkosten und Optionen",
      "Häufige Fehler vermeiden",
      "Sicherheit und Warnsignale",
    ],
  },
};